export default "__VITE_ASSET__91e95a8c__"